<template>
  <nav class="breadcrumbs" aria-label="breadcrumbs">
    <ul class="breadcrumbs__crumb-list flex-row flex-align-center">
      <li class="breadcrumbs__crumb-item">
        <a
          v-if="collection"
          :href="`/collections/${collection.handle}`"
          class="breadcrumbs__crumb-link"
        >
          {{ collection.title }}
        </a>
        <a
          v-else
          href="/"
          class="breadcrumbs__crumb-link"
        >
          Home
        </a>
        <span class="breadcrumbs__crumb-delimiter">
          <icon name="chevron-right" size="8px" />
        </span>
      </li>
      <li class="breadcrumbs__crumb-item">
        <span>{{ product.title }}</span>
      </li>
    </ul>
  </nav>
</template>

<script>
import Icon from '@/scripts/components/basic/Icon.vue';

export default {
  name: 'Breadcrumbs',
  components: {
    Icon,
  },
  props: {
    collection: {
      type: Object,
      default: () => ({}),
    },
    product: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="scss" scoped>
  .breadcrumbs {
    padding: rem(16) rem(16) rem(18) rem(24);
    background: $color-black-100;
    font-size: rem(12);

    @include tablet-up {
      margin: rem(37) 0 rem(34);
      padding: 0;
      background: none;
      font-size: rem(14);
    }
  }

  .breadcrumbs__crumb-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .breadcrumbs__crumb-item {
    color: $color-black-700;
    white-space: nowrap;

    &:last-of-type {
      overflow: hidden;
      text-overflow: ellipsis;      
    }
  }

  .breadcrumbs__crumb-link {
    color: inherit;
    line-height: (16 / 14);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .breadcrumbs__crumb-delimiter {
    padding: 0 rem(10);
  }
</style>